import React from 'react'
import { Stack, Tooltip } from '@mui/material'
import WorkIcon from '@mui/icons-material/Work'
import LinkIcon from '@mui/icons-material/Link'
import PhoneIcon from '@mui/icons-material/Phone'
import HomeIcon from '@mui/icons-material/Home'

interface DuplicateStatusIconsProps {
  hasPositions: boolean
  hasUrls: boolean
  hasPhones: boolean
  hasOnlyDanglingPhones: boolean
  hasAddresses: boolean
  hasOnlyDanglingAddresses: boolean
}

export const DuplicateStatusIcons: React.FC<DuplicateStatusIconsProps> = ({
  hasPositions,
  hasUrls,
  hasPhones,
  hasOnlyDanglingPhones,
  hasAddresses,
  hasOnlyDanglingAddresses
}) => {
  return (
    <Stack direction="row" spacing={1}>
      <Tooltip title={hasPositions ? 'Duplicate has active positions, remove them before deleting' : 'No positions assigned'}>
        <Stack>
          <WorkIcon
            color={hasPositions ? 'error' : 'success'}
          />
        </Stack>
      </Tooltip>
      <Tooltip title={hasUrls ? 'Duplicate has URL/Sources linked, remove or retire them before deleting' : 'No URL/Sources linked'}>
        <Stack>
          <LinkIcon
            color={hasUrls ? 'error' : 'success'}
          />
        </Stack>
      </Tooltip>
      <Tooltip title={
        hasPhones
          ? hasOnlyDanglingPhones
            ? 'Unlinked phones - will be auto-deleted'
            : 'Has linked phones - remove before deleting'
          : 'No phones linked'
      }>
        <Stack>
          <PhoneIcon
            color={hasPhones ? (hasOnlyDanglingPhones ? 'warning' : 'error') : 'success'}
          />
        </Stack>
      </Tooltip>
      <Tooltip title={
        hasAddresses
          ? hasOnlyDanglingAddresses
            ? 'Unlinked addresses - will be auto-deleted'
            : 'Has linked addresses - remove before deleting'
          : 'No addresses linked'
      }>
        <Stack>
          <HomeIcon
            color={hasAddresses ? (hasOnlyDanglingAddresses ? 'warning' : 'error') : 'success'}
          />
        </Stack>
      </Tooltip>
    </Stack>
  )
}
